const roles = ({
    state: {
        roles: {
            shopper : "shopper",
            traveller : "traveller",
        },
    },
    getters: {
        GET_ROLES : state => state.roles,
    }
});

export default roles;